/**
 * Frozen opaque ids for the official starter pack (#183, ADR-0004 §3).
 *
 * GENERATED ONCE by `scripts/gen-official-core.mjs` and COMMITTED as static
 * data. `mintVocabId` uses `randomUUID` (non-deterministic), so these ids are
 * frozen here rather than minted at load time — identity must be stable across
 * every build. DO NOT regenerate; edit by hand only if a token must be re-mapped.
 *
 * Maps the FORMER core.json token (e.g. `population`) to its opaque minted id.
 * The pack itself ([`official-core.json`]) is the source of truth for shape;
 * this map exists so engine code and tests can reference a known predicate/trait
 * by its old token without a name lookup (names are freely duplicable — id is
 * identity).
 */

/** Former-token → opaque `pred_` id for every official-pack predicate. */
export const OFFICIAL_CORE_PREDICATE_IDS = {
  "name": "pred_06b851f2-8bc3-4371-8f72-ded6ffb5896c",
  "population": "pred_90928ac2-e67d-4b97-a63c-aac86c8d25d5",
  "government": "pred_735e6654-d388-47e3-8f67-59e0eb205991",
  "canonical_calendar": "pred_59449352-9c55-4b76-9543-3392de71d7f6",
  "display_calendars": "pred_3fa6ef7f-dc8b-4cce-b775-c936a201e7f9",
  "accent_color": "pred_1771e7e9-b8ae-45ec-99dc-2e0d3704f1a5",
  "hero_image": "pred_5d237316-b439-448d-8afa-1a1f6c17ea3e",
  "prose_voice": "pred_3a768e45-a187-4fca-8594-53e876386abf",
  "setting_summary": "pred_e28c4158-8b0a-4c2f-b22c-95bc74dc332d",
  "campaign_kind": "pred_d2342713-d7f6-4b6a-81c3-db7da30e663b",
  "ruled_by": "pred_5d1697b9-7e90-42c9-ae8f-c74f3611dea2",
  "capital": "pred_a6df0471-8b05-43a5-874c-321dcbe7f172",
  "contained_in": "pred_df4101e8-135e-4e5e-b5c4-28a7413f3554",
  "laws": "pred_e613a462-bebb-4348-bdea-75c5caa00bd6",
  "species": "pred_6747aeef-6b60-4c3c-ba8b-8c8756991847",
  "gender": "pred_659f578b-c9b1-42e7-a016-8c2eae3ac61a",
  "appearance": "pred_ee2d8ade-74bf-4c97-8311-808ec911c04f",
  "portrait": "pred_ddc8e369-b41e-4f1a-99bb-c793788f6e1f",
  "born_in": "pred_72a21aa0-db5e-4fe7-b45f-7411027e7cdb",
  "died_in": "pred_999349d0-d179-4db8-ba49-574c15fef067",
  "cause_of_death": "pred_e279187f-515e-45a9-a64c-532e0f72d48b",
  "claim_to_fame": "pred_71cb4f5b-ac65-4fde-98bf-f79476e4c4f1",
  "reputation": "pred_76123ed0-d207-4213-8795-e881701259f2",
  "known_for": "pred_9f74d658-6ec5-4aad-92aa-456446114cd6",
  "magical_properties": "pred_d8ae12ef-c396-46a9-8477-90b56ff288de",
  "school": "pred_9e348f2a-a360-4449-8379-4e103d7924f4",
  "bound_to": "pred_9681ccff-bded-4f20-8aec-b0224d1791c1",
  "occurred_at": "pred_6ffae8ed-126b-4fe6-896c-a86fd45bdcb1",
  "participants": "pred_597c4868-787b-409f-bff0-c28e2cc3df81",
  "location": "pred_ecc561cb-e10f-4b3e-934a-3fd48210a23e",
  "caused_by": "pred_05fef77e-c286-4324-bfa9-7922a7683a11",
  "precedes": "pred_7fa92b99-beaa-4865-af18-d6996f67ac2e",
  // ── Calendar richness — recurring events (#235 / B2, 06-timeline.md §10.1/§10.2)
  // Object-keyed (`uniqueness_key: ['object']`) so a Lore carries multiple rules
  // (validity-versioned changes over time + concurrent observances); object is a
  // `recurrence_rule` value (B1 / #234). The rich editor is B5 (#238).
  "recurs_as": "pred_e56502a5-8809-4261-82b5-bc0faf744a0e",
  "objective": "pred_077b1ca2-c6f7-4777-878f-32e1236f1e5a",
  "reward": "pred_c35ec8bf-4d41-45da-8675-0c4bed95f3c0",
  "quest_status": "pred_6f0e44fd-4fe2-4013-880d-6534f58aa1be",
  "giver": "pred_5f8af83f-4f80-4e49-82b4-a0c6013f13d7",
  "real_world_span": "pred_bdb25792-51ff-456d-83dd-c42044beb2a4",
  "summary": "pred_45190650-81fe-4cc5-9557-2d25247b0ea0",
  "session_number": "pred_6185003a-ea0a-4f05-a06d-d453d0a896f4",
  "pending_auto_ratify_policy": "pred_d35b7f01-e70a-4aa0-b6fb-00d16ea61ac8",
  "controlled_by": "pred_8b87ec8b-7c7f-4690-a88d-641a8b0a1f1b",
  "visited": "pred_a5396199-a0e6-4f82-94b7-2c1f48a0163d",
  "creature_kind": "pred_98d48d14-4b0e-45fe-bbd3-66794fe8572a",
  "size": "pred_95b677b8-a37c-41a2-92c4-b4852762f2a4",
  "habitat": "pred_005c78d6-b4ed-44fa-b3a6-a0fe7851882b",
  "rider": "pred_426ff26a-0839-40b0-bf56-5cc7e4101196",
  "carrying_capacity": "pred_8454a183-d490-43e0-9ae3-5ed5c6e896f9",
  "temperament": "pred_358df233-4155-4cab-a53f-0268ed20484b",
  "instance_of": "pred_a727d5a8-28b6-411c-bae0-26eae0d2f73d",
  // ── Geography v1 — Depiction / Map predicates (#205, 05-geography.md §4–§5)
  "subject": "pred_e584ac52-cfe1-4c0d-b210-a01c601530c7",
  "representation": "pred_90fb71c9-bac2-4f35-8f63-f967c8dc9d3b",
  "frame_override": "pred_a3e687eb-44f8-4f17-bd7b-9f1897f357cb",
  "background": "pred_fda4b9b5-6b1a-458a-ba42-38a589da542e",
  "layers": "pred_9b3ffec5-7a40-40a0-97db-4f3b6fd72222",
  "parent_depiction": "pred_0dcbdbc2-fbb6-44b4-a530-27023d2e08df",
  "scale": "pred_a0a9da35-6bd4-4f4c-ae83-1b68a8bc79ef",
  "projection": "pred_082dbe38-934c-4fd5-becf-9a2074f60b1f",
  "style": "pred_a249c3e7-de07-468b-8c0f-8613743a895d",
  "orientation": "pred_a61099c1-450e-4ea8-97f5-a29f47602298",
} as const satisfies Record<string, string>;

/** Former-token → opaque `trait_` id for every official-pack trait. */
export const OFFICIAL_CORE_TRAIT_IDS = {
  "inhabited": "trait_583b1c12-540c-474d-bdfe-8aee96b6ddef",
  "campaign": "trait_6a9dc0c5-6f90-49ce-b8ae-cd65419e33bb",
  "governed": "trait_d1848314-b7c7-4dbd-bc4e-a88d116db79b",
  "embodied": "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
  "mortal": "trait_b73ea838-f937-4d4a-b837-7612036d409e",
  "notable": "trait_67f55d1f-6b7b-4534-a158-96c1c3147e8d",
  "magical": "trait_7482796a-d0a0-4d94-9bc2-d392a45fd4a0",
  "scheduled": "trait_cac9c54a-6d68-489b-b916-b3a51f5e91c4",
  "quest": "trait_6927d058-b89b-42b5-beb0-4b4eb2787f80",
  "session": "trait_2d9bacaa-276a-4fe2-9918-ea38a8ba08bd",
  "traveler": "trait_7c628628-8d72-4a5c-be2d-135ad22e28e0",
  "creature": "trait_b0ee7ba7-bd8c-4784-b238-df19a9ae5ba0",
  "mount": "trait_8e55a07e-803f-453f-9095-266f00015df0",
  // ── Geography v1 — Depiction / Map traits (#205, 05-geography.md §4–§5)
  "depicts": "trait_35883d22-f123-4be5-b691-f96137e5414d",
  "cartographic": "trait_e436ddf0-2b68-4403-8425-115ef8f49517",
} as const satisfies Record<string, string>;

/**
 * Frozen opaque `enm_` ids for the `orientation` (cartographic) enum
 * (#205, 05-geography.md §5). The fact stores the option id, never the
 * display name; `north_up` is the design-declared default.
 */
export const OFFICIAL_CORE_ORIENTATION_ENUM_IDS = {
  "north_up": "enm_58c22399-e126-47c8-9ef0-f159a8fb8088",
  "east_up": "enm_2ea29264-d64a-4bdb-8d6a-fcfc56b5fa32",
  "none": "enm_f051225d-53cd-48f7-8a40-044dbc0f3437",
} as const satisfies Record<string, string>;

export type OfficialCorePredicateToken = keyof typeof OFFICIAL_CORE_PREDICATE_IDS;
export type OfficialCoreTraitToken = keyof typeof OFFICIAL_CORE_TRAIT_IDS;
export type OfficialCoreOrientationToken = keyof typeof OFFICIAL_CORE_ORIENTATION_ENUM_IDS;
